import { Button } from 'src/components';
import EmailConfirmationWrapper from 'src/components/Wrapper/EmailConfirmationWrapper';

type GetStartedData = {
  isCheckedEmail: boolean;
  email: string;
};

type GetStartedProps = GetStartedData & {
  updateFields: (fields: Partial<GetStartedData>) => void;
  nextStep: () => void;
};

const GetStarted = ({ nextStep, updateFields, email }: GetStartedProps) => {
  return (
    <EmailConfirmationWrapper>
      <h1 className="text-blue-950 text-[22px] font-bold ">
        Let’s Get Started!
      </h1>
      <div className="w-[432px] text-center">
        <p className="text-blue-950 text-sm font-medium font-SFProDisplay leading-5">
          You have confirmed <span className="text-lightBlue">{email} </span>{' '}
          and set
          <br />
          your credentials
        </p>
        <p className="text-blue-950 text-sm font-medium font-SFProDisplay leading-5 mt-3">
          You are ready to start a new TeamCap workspace for
          <br />
          your organization.
        </p>
      </div>
      <Button
        variant="normal"
        size="sm"
        label="Continue"
        className="block w-[360px] mt-5"
        type="submit"
        onClick={() => {
          updateFields({ isCheckedEmail: true });
          nextStep();
        }}
      />
    </EmailConfirmationWrapper>
  );
};

export default GetStarted;
